import { apiGet, apiPost, unwrap } from './apiClient';
import type {
  ResponseDTO,
  ApplicationDTO,
  AppStoreApplication,
  BatchOperationResult,
} from '@/types/api';

const BASE = '/api/v1/appstore';

export async function searchApps(
  term: string,
  platform: 'iOS' | 'macOS',
  limit = 10,
  country = 'US'
) {
  const res = await apiGet<ResponseDTO<ApplicationDTO[]>>(
    `${BASE}/apps/search`,
    { params: { term, platform, limit, country }, includeTenantHeader: true }
  );
  return unwrap(res);
}

export async function fetchAppByTrackId(trackId: string, country = 'US') {
  const res = await apiGet<ResponseDTO<AppStoreApplication>>(
    `${BASE}/apps/fetch/${trackId}`,
    { params: { country }, includeTenantHeader: true }
  );
  return unwrap(res);
}

export async function savePublicApp(app: AppStoreApplication) {
  const res = await apiPost<ResponseDTO<AppStoreApplication>>(
    `${BASE}/public/apps`,
    app,
    { includeTenantHeader: true }
  );
  return unwrap(res);
}

export async function batchDeleteApps(appIds: string[]) {
  const res = await apiPost<ResponseDTO<BatchOperationResult>>(
    `${BASE}/apps/delete`,
    appIds,
    { includeTenantHeader: true }
  );
  return unwrap(res);
}
